export default __webpack_public_path__ + "static/media/KD.32d1a9f8.svg";